import { SubscriptionStatus } from 'src/shared/features/subscriptions/schemas/subscriptions'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'

export const useIsSubscribed = () => {
  const { data: user } = useMyUserData()

  return (
    (user?.subscription?.status === SubscriptionStatus.ACTIVE ||
      user?.subscription?.status === SubscriptionStatus.TRIALING) &&
    user?.subscription?.currentPeriodEnd > new Date().toISOString()
  )
}
